import React, { Component } from "react";
import "./index.less";
import { langCheck } from "Pub/js/utils";

export default class NoAuthority extends Component {
    render() {
        const { text } = this.props;
        return (
            <div className="no-authority">
                <p className="no-authority-text">
                    {text || langCheck('0000PUB-000565' /* 暂无权限查看 */)}
                    <br />
                    {langCheck('0000PUB-000566') /* 请联系管理员添加 */}
                </p>
            </div>
        );
    }
}